import CreateUserPage from './CreateUserPage';
import EditUserPage from './EditUserPage';
import UsersPage from './UsersPage';

export {CreateUserPage, EditUserPage, UsersPage};


/** WEBPACK FOOTER **
 ** ./src/modules/users/components/index.js
 **/